import { ApplicationMessageSource } from '../../core/models/application-message-source';
import { MessageType } from '../../core/models/enum/message-type';
import { ApplicationMessage } from '../../core/models/application-message';
import { CustomMessageService } from '../../core/message.service';
import { CommonLookupItem } from '../../shared/models/common-lookup-item.model';
import { LookupService } from '../../shared/services/lookup.service';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { SubscriberService } from '../shared/services/subscriber.service';
import { SubscriberModel } from '../shared/models/subscriber-model';
import { LazyLoadEvent } from 'primeng/api';
import { SubscriberFilterModel } from '../shared/models/subscriber-filter-model';
import { PagingFilter } from '../../shared/models/paging-filter.model';
import { SubscriberStatus } from './subscriber-status.enum';
import { SelectItem } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { Table } from 'primeng/table';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-subscriber-list',
  templateUrl: './subscriber-list.component.html',
  styleUrls: ['./subscriber-list.component.less'],
  standalone: false,
})
export class SubscriberListComponent implements OnInit {
  public switchFilterStatuses: SelectItem[];
  public switchFilterStatus: number;
  public SwitchFilterStatus: any = SubscriberStatus;

  public subscriberList: SubscriberModel[];

  public filterPagingWrapper: PagingFilter<SubscriberFilterModel>;

  public totalRecords: number;

  public lastLoadEvent: LazyLoadEvent;

  public pageSize: number;

  public email: string;

  public providerWebsiteId: number;

  public websiteList: SelectItem[];

  constructor(
    private translationService: TranslateService,
    private subcscriberService: SubscriberService,
    private config: ConfigurationService,
    private lookupService: LookupService,
    private messageService: CustomMessageService
  ) {
    this.switchFilterStatuses = [
      {
        label: this.translationService.instant('label.Pending'),
        value: SubscriberStatus.Pending,
      },
      {
        label: this.translationService.instant('label.Active'),
        value: SubscriberStatus.Active,
      },
      {
        label: this.translationService.instant('label.Deleted'),
        value: SubscriberStatus.Deleted,
      },
    ];

    this.filterPagingWrapper = new PagingFilter(new SubscriberFilterModel());
    this.switchFilterStatus = SubscriberStatus.Pending;
    this.websiteList = [];
    this.subscriberList = [];
    this.totalRecords = 0;
  }

  public onLoad(event: LazyLoadEvent) {
    this.filterPagingWrapper.pagingInfo.start = event.first;
    this.filterPagingWrapper.pagingInfo.limit = event.rows;
    this.lastLoadEvent = event;
    let filters: { [index: string]: any } = [];

    if (event.filters != null) {
      for (let f in event.filters) {
        {
          filters[f] = event.filters[f].value;
        }
      }
    }

    this.filterPagingWrapper.filter.email = filters['email'];
    this.filterPagingWrapper.filter.providerWebsiteId = <number>(
      filters['originWebsite']
    );
    this.onFilter();
  }

  public onFilter(dt: Table = null) {
    if (dt != null) dt.reset();
    this.filterPagingWrapper.pagingInfo.start =
      this.filterPagingWrapper.pagingInfo.start || 0;
    this.filterPagingWrapper.filter.subscriberStatusId =
      this.switchFilterStatus;
    this.subcscriberService
      .listSubscriber(this.filterPagingWrapper)
      .subscribe((d) => {
        this.totalRecords = d.totalCount;
        this.subscriberList = d.items;
      });
  }

  public onDeleteClick(subscriber: SubscriberModel) {
    if (!confirm(this.translationService.instant('message.AreYouSure'))) {
      return;
    }
    this.subcscriberService
      .deleteSubscriber(subscriber.subscriberId)
      .subscribe((result) => {
        this.messageService.pushMessage(<ApplicationMessage>{
          type: MessageType.Success,
          sourceId: ApplicationMessageSource.global,
          summary: '',
          detail: this.translationService.instant('message.SaveMessage'),
        });
        this.onLoad(this.lastLoadEvent);
      });
  }

  ngOnInit() {
    let config = this.config.getCachedConfig();

    let lookupData = this.lookupService.getCachedLookupData();

    this.pageSize = config.defaultPageSize;

    this.switchFilterStatus = SubscriberStatus.Pending;

    let list = lookupData.providerWebsiteList;

    this.websiteList.push({
      label: this.translationService.instant('label.Website'),
      value: null,
    });

    list.forEach((w) =>
      this.websiteList.push({ label: w.text, value: w.value })
    );
  }
}
